import "./App.css";
import React from "react";
import SeatsLayout from "./components/SeatsLayout";

const App = () => <SeatsLayout />;

export default App;
